/**
 * Symbol -> sector, for views that need a sector when the scored payload did
 * not carry one. Extracted from SectorDonut.js on 2026-09-23 so the portfolio
 * heatmap could group by sector without a second copy of the table drifting
 * away from the first.
 *
 * This is a FALLBACK. Always prefer `score.sector` from the API when present;
 * this list is hand-maintained and will lag new names. SECTOR_FOR() returns
 * 'Other' rather than undefined so an unknown ticker still gets a tile.
 */

// Sector mapping — covers equities, ETFs, crypto, and specialty sectors
const SECTOR_MAP = {
  // Technology
  AAPL: 'Technology', MSFT: 'Technology', GOOGL: 'Technology', GOOG: 'Technology',
  NVDA: 'Technology', META: 'Technology', AMD: 'Technology', AVGO: 'Technology',
  CRM: 'Technology', INTC: 'Technology', ORCL: 'Technology', ADBE: 'Technology',
  CSCO: 'Technology', QCOM: 'Technology', TXN: 'Technology', MU: 'Technology',
  AMAT: 'Technology', ASML: 'Technology', PLTR: 'Technology', SNOW: 'Technology',
  SHOP: 'Technology', SQ: 'Technology', NET: 'Technology', DDOG: 'Technology',
  PANW: 'Technology', CRWD: 'Technology', ZS: 'Technology', TSM: 'Technology',
  // Consumer Discretionary
  AMZN: 'Consumer Disc.', TSLA: 'Consumer Disc.', HD: 'Consumer Disc.',
  NKE: 'Consumer Disc.', SBUX: 'Consumer Disc.', TGT: 'Consumer Disc.',
  LOW: 'Consumer Disc.', BKNG: 'Consumer Disc.', ABNB: 'Consumer Disc.',
  // Financials
  JPM: 'Financials', BAC: 'Financials', GS: 'Financials', V: 'Financials',
  MA: 'Financials', MS: 'Financials', C: 'Financials', WFC: 'Financials',
  BLK: 'Financials', SCHW: 'Financials', COIN: 'Financials',
  // Healthcare
  JNJ: 'Healthcare', UNH: 'Healthcare', LLY: 'Healthcare', PFE: 'Healthcare',
  ABBV: 'Healthcare', MRK: 'Healthcare', TMO: 'Healthcare', ABT: 'Healthcare',
  // Energy
  XOM: 'Energy', CVX: 'Energy', COP: 'Energy', SLB: 'Energy',
  EOG: 'Energy', MPC: 'Energy', OXY: 'Energy',
  // Uranium / Nuclear
  CCJ: 'Uranium/Nuclear', URA: 'Uranium/Nuclear', UUUU: 'Uranium/Nuclear',
  LEU: 'Uranium/Nuclear', DNN: 'Uranium/Nuclear', SMR: 'Uranium/Nuclear', OKLO: 'Uranium/Nuclear',
  // Consumer Staples
  PG: 'Consumer Staples', KO: 'Consumer Staples', PEP: 'Consumer Staples',
  WMT: 'Consumer Staples', COST: 'Consumer Staples',
  // Communication
  NFLX: 'Communication', DIS: 'Communication', CMCSA: 'Communication',
  // Industrials
  CAT: 'Industrials', HON: 'Industrials', UNP: 'Industrials', BA: 'Industrials',
  RTX: 'Industrials', DE: 'Industrials', GE: 'Industrials', LMT: 'Industrials',
  // Utilities
  NEE: 'Utilities', DUK: 'Utilities', SO: 'Utilities',
  // Real Estate
  AMT: 'Real Estate', PLD: 'Real Estate', O: 'Real Estate',
  // Materials / Mining
  COPX: 'Materials/Mining', FCX: 'Materials/Mining', NEM: 'Materials/Mining',
  // ETFs
  SPY: 'ETF - Index', QQQ: 'ETF - Index', IWM: 'ETF - Index', VOO: 'ETF - Index', VTI: 'ETF - Index', RSP: 'ETF - Index',
  EWJ: 'ETF - Intl', EEM: 'ETF - Intl', VWO: 'ETF - Intl',
  XLK: 'ETF - Sector', XLF: 'ETF - Sector', XLE: 'ETF - Sector', SMH: 'ETF - Sector', SOXX: 'ETF - Sector', ARKK: 'ETF - Sector',
  GLD: 'Commodities', SLV: 'Commodities', IAU: 'Commodities',
  TLT: 'Fixed Income', BND: 'Fixed Income', STRC: 'Fixed Income',
  // Digital Assets
  BTC: 'Digital Assets', ETH: 'Digital Assets', SOL: 'Digital Assets',
  AVAX: 'Digital Assets', NEAR: 'Digital Assets', SUI: 'Digital Assets',
  LINK: 'Digital Assets', AAVE: 'Digital Assets', ONDO: 'Digital Assets',
  HYPE: 'Digital Assets', WLD: 'Digital Assets', TON: 'Digital Assets',
  TIA: 'Digital Assets', AKT: 'Digital Assets', OP: 'Digital Assets',
  RNDR: 'Digital Assets', DOGE: 'Digital Assets', XRP: 'Digital Assets',
  ADA: 'Digital Assets', DOT: 'Digital Assets', MATIC: 'Digital Assets',
  ATOM: 'Digital Assets', UNI: 'Digital Assets', MKR: 'Digital Assets',
};

export { SECTOR_MAP };

export function SECTOR_FOR(symbol) {
  return SECTOR_MAP[(symbol || '').toUpperCase()] || 'Other';
}
